import $ from 'jquery';
import eventBus         from 'EventBus.js';
import themeService     from 'ThemeService.js';
import pageSyncService from 'PageSyncService';
import undoService from 'UndoService';
import focusController from 'FocusController'

import util             from 'util/Util.js';
import { pickerCfg } from 'pickerCfg.js';

import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/theme/misc.ejs';

class MiscView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.model.set('seperatorColor', themeService.resolve('~seperatorColor'), {silent : true} );
        this.model.set('seperatorSize', themeService.resolve('~seperatorSize'), {silent: true} );

        this.events = {
            'change #seperatorSize': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'change #seperatorColor': 'updateColorText',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal  = this.model.get(propName);
        const oldThemeVal  = themeService._theme['~'+propName];

        this.model.set( propName, propVal, {silent: true} );
        themeService._theme['~'+propName] =  propVal;
        this.render();
        eventBus.trigger('SeparatorThemeChange');
      undoService.add({
        undo:() => {
          this.model.set(propName, oldPropVal,{silent:true});
          themeService._theme['~'+propName] =  oldThemeVal;
          pageSyncService.renderCurrentPageView();
          focusController.switchPropsViews();
        },
        redo: () => {
          this.model.set(propName, propVal,{silent:true});
          themeService._theme['~'+propName] =  propVal;
          pageSyncService.renderCurrentPageView();
          focusController.switchPropsViews();
        }
      })
    }

    updateColorText(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal  = this.model.get(propName);
        const oldThemeValue=themeService._theme['~' + propName];

        if (util.isValidColorcode(propVal)) {
            let color = this.resolveColor(propVal);
            this.model.set(propName, color, {silent: true});
            themeService._theme['~' + propName] = color;
            this.render();
            $('#' + propName).val(color);
            this.addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,color);
            eventBus.trigger('SeparatorThemeChange');
        }
        else {
          this.render();
        }
    }

    updateColorAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        const oldPropVal  = this.model.get(propName);
        const oldThemeValue=themeService._theme['~' + propName];

        let color = this.resolveColor(propVal);
        themeService._theme['~' + propName] = color;
        this.model.set( propName, color, {silent:true} );
        this.render();
        $('#' + propName).val(color);
        this.addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,color);
        eventBus.trigger('SeparatorThemeChange');
    }

  addUndoRedoColorAction(propName,oldThemeValue,oldPropVal,currentColor){
    undoService.add({
      undo:() => {
        this.model.set(propName, oldPropVal,{silent:true});
        themeService._theme['~' + propName] = oldThemeValue;
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
        $('#' + propName).val(oldPropVal);
      },
      redo: () => {
        this.model.set(propName, currentColor,{silent:true});
        themeService._theme['~' + propName] = currentColor;
        //eventBus.trigger('InputThemeChange');
        pageSyncService.renderCurrentPageView();
        focusController.switchPropsViews();
        $('#' + propName).val(currentColor);
      }
    })
  }


    render() {
        super.render();
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();
        return this;
    }

}

export default MiscView;
